/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DisciplineSubgroupGetAllDTO,
    DisciplineSubgroupGetAllDTOFromJSON,
    DisciplineSubgroupGetAllDTOFromJSONTyped,
    DisciplineSubgroupGetAllDTOToJSON,
} from './DisciplineSubgroupGetAllDTO';

/**
 * 
 * @export
 * @interface DisciplineSubgroupGetAllDTOPagedResponse
 */
export interface DisciplineSubgroupGetAllDTOPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof DisciplineSubgroupGetAllDTOPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof DisciplineSubgroupGetAllDTOPagedResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof DisciplineSubgroupGetAllDTOPagedResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<DisciplineSubgroupGetAllDTO>}
     * @memberof DisciplineSubgroupGetAllDTOPagedResponse
     */
    data?: Array<DisciplineSubgroupGetAllDTO> | null;
}

export function DisciplineSubgroupGetAllDTOPagedResponseFromJSON(json: any): DisciplineSubgroupGetAllDTOPagedResponse {
    return DisciplineSubgroupGetAllDTOPagedResponseFromJSONTyped(json, false);
}

export function DisciplineSubgroupGetAllDTOPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisciplineSubgroupGetAllDTOPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(DisciplineSubgroupGetAllDTOFromJSON)),
    };
}

export function DisciplineSubgroupGetAllDTOPagedResponseToJSON(value?: DisciplineSubgroupGetAllDTOPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'pageSize': value.pageSize,
        'totalCount': value.totalCount,
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(DisciplineSubgroupGetAllDTOToJSON)),
    };
}

